










export default {
  name: 'NotFound'
};
